export default __webpack_public_path__ + "static/media/eye-crossed-out.f18c6cd4.svg";